import { useStoreRoot } from '~/stores/abstract/root';
import { useStoreGamesStrapi } from '~/stores/strapi/games';
import { gameUrlFromTitle } from '~/utils/gameUrl';

export const useUrlConstructor = () => {
  const storeGamesStrapi = useStoreGamesStrapi();

  const getGameUrl = (
    game: { id: string; provider: string; title: string },
    isPartialPath = false
  ) => {
    let gameUrl = game.provider
      ? `${game.provider}/${gameUrlFromTitle(game.title)}`
      : `${gameUrlFromTitle(game.title)}`;

    const findGameInStrapi = storeGamesStrapi.games.find(
      (gameStrapi) => gameStrapi.gameId === game.id
    );

    if (findGameInStrapi) {
      gameUrl =
        findGameInStrapi.url[0] === '/' ? findGameInStrapi.url.slice(1) : findGameInStrapi.url;
    }

    return isPartialPath ? gameUrl : useStoreRoot().localePath(`/games/${gameUrl}`);
  };

  return {
    getGameUrl,
  };
};
